<div class="form-container">
  
  <div class="subform-container">
    <div class="title-text">{{getString('changeUsernameText')}}</div>
    <div class="form-field">
      <app-input-field [type]="'text'" [placeholder]="getString('newUsername')" (valueChanged)="onUsernameChange($event)"></app-input-field>
    </div>

    <div class="form-field">
      <button type="button" class="blue-button" (click)="changeUsername()">{{getString('change')}}</button>
      <button type="button" (click)="close.emit()">{{getString('cancel')}}</button>
    </div>

    <div class="message-container">
        <div class="red-text" *ngIf="invalidUsername">{{invalidUsernameMessage}}</div>
        <div class="red-text" *ngIf="serverError">{{serverMessage}}</div>
    </div>

  </div>

</div>
